import React, { useEffect, useState } from 'react';
import { Dropdown, Badge } from '@superops/ui-design-system';
import { getTranslatedText, useIntl } from '@nile/components';
import { AccountClient } from '@nile/graphql/src';
import { GET_BUSINESS_FUNCTION_LIST } from '@nile/itsm/src/graphql';
import { useLazyQuery } from '@apollo/client';
import { SVGIcon } from '@superops/super-icons';

interface DepartmentSelectProps {
  onChange: (department: any) => void;
  department?: any;
  showIcon?: boolean;
  disableApiCalls?: boolean;
  prePopulateOptions?: any;
  disabled?: boolean;
}

function DepartmentSelect(props: DepartmentSelectProps) {
  const intl = useIntl();
  const {
    onChange,
    department,
    showIcon,
    disableApiCalls = false,
    prePopulateOptions = null,
    disabled = false
  } = props;

  const [departmentOptions, setDepartmentOptions] = useState<any[] | null>(
    null
  );
  const [selectedValue, setSelectedValue] = useState<any>(null);

  useEffect(() => {
    if (department) {
      setSelectedValue({
        label: department.name,
        value: department.businessFunctionId || department.value,
        name: department.name
      });
    } else {
      setSelectedValue(null);
    }
  }, [department]);

  useEffect(() => {
    if (prePopulateOptions) {
      setDepartmentOptions(prePopulateOptions);
    }
  }, [prePopulateOptions]);

  const [getDepartments, { loading: departmentLoading }] = useLazyQuery(
    GET_BUSINESS_FUNCTION_LIST,
    {
      client: AccountClient,
      fetchPolicy: 'cache-and-network',
      onCompleted: function(res: any) {
        const data = res?.getBusinessFunctionList;
        const options = data?.map((el: any) => {
          return {
            ...el,
            name: el?.name,
            value: el?.businessFunctionId,
            label: el?.name
          };
        });
        setDepartmentOptions(options);
      }
    }
  );

  return (
    <div className="w100">
      <div className="flex actr g10">
        {showIcon && (
          <div className="flex actr">
            <Badge size="small" radial status="attention">
              <SVGIcon name="Department" />
            </Badge>
          </div>
        )}
        <div className="f11">
          <Dropdown
            value={selectedValue || null}
            isClearable
            onChange={(val: any) => onChange(val)}
            options={departmentOptions || []}
            classNamePrefix="value_selector"
            menuPlacement="auto"
            placeholder={getTranslatedText(intl, 'common.select.department')}
            onMenuOpen={
              disableApiCalls || prePopulateOptions ? undefined : getDepartments
            }
            menuPortalTarget={document.body}
            disabled={disabled}
            isLoading={departmentLoading}
            closeMenuOnScroll={(e: any) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{
              menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
              menu: (base: any) => ({ ...base, zIndex: 9999 })
            }}
          />
        </div>
      </div>
    </div>
  );
}
export { DepartmentSelect };
